import { useEffect, useState } from "react";
import { thi_timestamp, thi_date } from "./../../services/Helper";

function AllTestResults({ results, resultDate, oldResults }) {
  const [TableDates, setTableDates] = useState([]);
  const [TableResults, setTableResults] = useState([]);

  console.log(oldResults);

  const formatTime = (dt) => {
    if (!dt) return "";
    const d = new Date(dt);
    return `${d.getHours().toString().padStart(2, "0")}:${d.getMinutes().toString().padStart(2, "0")}`;
  };

  useEffect(() => {
    const totalParams = Object.values(results).length;
    const resultHistory = 3;
    const sorted = Object.entries(results)
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([, v]) => v)
      .filter((a) => a[0].result !== null || (a[0].parameterName && (a[0].parameterName.includes('|||||') || a[0].parameterName.includes('-----'))));

    // Find dates from first parameter that has old results
    let dates = [];
    for (const a of sorted) {
      const { parameterCode, testId, doTest } = a[0];
      var old = oldResults.filter(
        (o) =>
          o.TESTID !== testId &&
          thi_timestamp(o.DOTEST) < thi_timestamp(doTest),
      );
      old = old.slice(-(resultHistory * totalParams));
      old = old.reverse();
      old = old.filter((o) => parameterCode === o.PARAMETERCODE);
      if (old.length > 0) {
        dates = old.map((o) => o.DORESULTRECORDING).filter(Boolean);
        break;
      }
    }
    setTableDates(dates);

    const comparedResults = sorted.map((a) => {
      const { parameterCode, parameterName, testId, doTest } = a[0];

      // Separator row - skip processing
      if (parameterName && (parameterName.includes('|||||') || parameterName.includes('-----'))) {
        a[0].RESULTS = Array(dates.length).fill(null);
        a[0].isSeparator = true;
        return a;
      }

      var old = oldResults.filter(
        (o) =>
          o.TESTID !== testId &&
          thi_timestamp(o.DOTEST) < thi_timestamp(doTest),
      );
      old = old.slice(-(resultHistory * totalParams));
      old = old.reverse();
      old = old.filter((o) => parameterCode === o.PARAMETERCODE);
      var res = old.map((o) => o.PARAMETERRESULT);
      // Pad to match dates length
      while (res.length < dates.length) res.push(null);
      a[0].RESULTS = res.slice(0, dates.length);
      return a;
    });
    setTableResults(comparedResults);
  }, [oldResults, results]);

  const getFormattedResult = (result, lower, upper) => {
    if (result === null || result === undefined || result === "") return "--";

    // Check if result is a string that cannot be converted to a number
    const numericResult = parseFloat(result);
    if (isNaN(numericResult)) {
      // Return the string value as-is for non-numeric results like "Pale Yellow"
      return result;
    }

    // For numeric results, check if they're outside normal range
    if (numericResult <= lower || numericResult >= upper) {
      return <span className="fw-bold text-danger">{numericResult}</span>;
    }
    return numericResult;
  };

  return (
    <table
      className="table table-striped"
      style={{ tableLayout: "fixed", width: "100%", lineHeight: "1" }}
    >
      <thead>
        <tr>
          <td style={{ width: "15%" }}>Name</td>
          <td style={{ width: "10%", textAlign: "center" }}>
            <small>
              <strong>
                {resultDate ? (
                  <>
                    {thi_date(resultDate)}
                    <br />
                    {formatTime(resultDate)}
                  </>
                ) : (
                  "Result"
                )}
              </strong>
            </small>
          </td>
          {TableDates.map((t, i) => (
            <td key={i} style={{ width: "10%", textAlign: "center" }}>
              <small>{thi_date(t)}</small>
              <br />
              <small>{formatTime(t)}</small>
            </td>
          ))}
          <td style={{ width: "10%", textAlign: "center" }}>Normal</td>
          <td style={{ width: "10%", textAlign: "center" }}>Unit</td>
        </tr>
      </thead>
      <tbody>
        {Object.values(TableResults).map((r, i) => {
          const rows = Object.values(TableResults);
          const nextIsSeparator = rows[i + 1]?.[0]?.isSeparator;
          const {
            parameterName,
            result,
            RESULTS = [],
            normalRange,
            units,
            lowerValue,
            upperValue,
            isSeparator,
          } = r[0];

          if (isSeparator) {
            const totalCols = 4 + TableDates.length;
            return (
              <tr key={i}>
                {Array.from({ length: totalCols }).map((_, ci) => (
                  <td key={ci} style={{ padding: '10px 0', background: 'white', borderBottom: 'none', '--bs-table-bg': 'white', '--bs-table-striped-bg': 'white' }}>
                    <div style={{ borderTop: '2px solid #dee2e6', width: '100%' }}></div>
                  </td>
                ))}
              </tr>
            );
          }

          return (
            <tr key={i} className={nextIsSeparator ? 'before-separator' : ''} style={{ padding: 0 }}>
              <td
                style={{
                  padding: "1px 6px",
                  fontSize: "13px",
                  verticalAlign: "middle",
                }}
              >
                {parameterName}
              </td>
              <td
                style={{
                  textAlign: "center",
                  fontSize: "15px",
                  fontWeight: "bold",
                  color: "#0d6efd",
                  padding: "1px 6px",
                  verticalAlign: "middle",
                }}
              >
                {getFormattedResult(result, lowerValue, upperValue)}
              </td>
              {RESULTS.map((res, idx) => (
                <td
                  key={idx}
                  style={{
                    textAlign: "center",
                    padding: "2px 8px",
                    fontSize: "14px",
                    verticalAlign: "middle",
                  }}
                >
                  {getFormattedResult(res, lowerValue, upperValue)}
                </td>
              ))}
              <td
                style={{
                  textAlign: "center",
                  padding: "1px 6px",
                  fontSize: "12px",
                  verticalAlign: "middle",
                }}
              >
                {normalRange}
              </td>
              <td
                style={{
                  textAlign: "center",
                  padding: "1px 6px",
                  fontSize: "12px",
                  verticalAlign: "middle",
                }}
              >
                {units}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export default AllTestResults;
